import type {
    SubChartType,
    ICTAxDataSource,
    ICTDPt,
    ICTNumDataSource,
    IEGAxis,
    ICTDLbl,
} from '@tencent/slide-sdk-pb-model';

export interface ISubChartCustomData<Type extends SubChartType> {
    /**
     * 子表类型
     */
    type: Type;

    /**
     * 坐标轴添加索引
     */
    axesAddIndex?: number;

    /**
     * 子表包含的坐标轴
     */
    axes?: IEGAxis[];
}

export enum ValuesDataSourceType {
    numberRef = 'nr',
    numberLiteral = 'nl',
    stringRef = 'sr',
    stringLiteral = 'sl',
}

export interface IValuesDataSource {
    formatCode?: string;
    type: ValuesDataSourceType;
}

export interface ICategory {
    idx: number;
    categoryPoint?: IValuePointData;
    valuePoint?: IValuePointData;
    dataLabel?: ICTDLbl;
    dataPoint?: ICTDPt;
}

export interface IChartSerCustomData {
    /**
     * cat & val & dPt 原本三个集合，通过idx关联到一个集合categories
     */
    categories: Array<ICategory>;
    /**
     * 系列是否无效。当Values无数据，且无NumberingCache标签时，值为true，否则为false
     */
    disable: boolean;
    /**
     * 当前ser中的分类count数
     */
    valueCount?: number;
    /**
     * 全局分类坐标轴的数据源信息（不拆到categories里的原因是，需要做导出后还原）
     */
    categoryAxisData?: IValuesDataSource;
    /**
     * 全局值坐标轴的数据源信息
     */
    values?: IValuesDataSource;
    /**
     * 额外剩下的dataPoint，比如：子母图含有"其他"项，存在大于count数的data point
     */
    otherDPt?: ICTDPt;
    /**
     * 额外剩下的dataLabel，比如：子母图含有"其他"项，存在大于count数的data label
     */
    otherDLbl?: ICTDLbl;
}

export interface IValuePointData {
    /**
     * 对应 xsd中 XX.(NumRef | StrRef).xxCache.pt.v
     */
    v?: string;
    /**
     * 格式化代码
     */
    formatCode?: string;
}

interface ISerSharedData {
    val?: ICTNumDataSource;
    cat?: ICTAxDataSource;
    dPt?: Array<ICTDPt>;
}
export type IChartSerOmit<T extends ISerSharedData = ISerSharedData> = Omit<T, 'val' | 'cat' | 'dPt' | 'xVal' | 'yVal'>;
